import React from 'react';
import { successUpdateMsg } from '../../../../components/atoms/const';
import Form from '../../../../components/molecules/forms';
import Modal from '../../../../components/organisms/modals';
import { DollarRefund } from '../../../../components/atoms/icons';

interface Props {
    paymentAmount: number | null;
    paymentDate: string | null;
    id: number;
    modal: {
        load: boolean;
        after: () => void;
        result: any;
    };
    formik: any;
}

function PaymentStatus(props: Props) {
  const {
    paymentAmount, paymentDate, id, modal, formik,
  } = props;

  // Date Render 2022-05-06T10:45:14
  const renderDate = (date: string | null):string => {
    if (date) {
      const onlyDate = date.split('T')[0].split('-');
      return `${onlyDate[1]}/${onlyDate[2]}/${onlyDate[0]}`;
    }
    return '-';
  };

  const renderModalBody = React.useMemo(() => {
    if (modal.result) return successUpdateMsg.SUCCESS_SEND_REFUND;
    return (
      <div>
        <Form.Default
          id="paymentAmount"
          placeholder="Enter Amount"
          type="number"
          value={formik.values.paymentAmount}
          onBlur={formik.handleBlur}
          isInvalid={!!formik.errors.paymentAmount && formik.touched.paymentAmount}
          errorMsg={formik.errors.paymentAmount}
          onChange={(e) => formik.setFieldValue('paymentAmount', e.target.value)}
        />
      </div>
    );
  }, [modal.result, formik]);

  if (!paymentAmount && !paymentDate) {
    return (
      <div className="d-flex align-items-center" style={{ width: 120 }}>
        <div className="fz-14">Not-Paid</div>
        <Modal.Default
          cancelLabel="Cancel"
          submitLabel="Pay"
          title="Commission Payment"
          body={renderModalBody}
          closeButton
          isLoading={modal.load}
          onAfterResult={modal.after}
          result={modal.result}
          onInit={() => formik.setFieldValue('id', id)}
          onSubmit={formik.handleSubmit}
        >
          <div className="ms-2">
            <DollarRefund />
          </div>
        </Modal.Default>
      </div>
    );
  }
  return (
    <div className="d-flex justify-content-end align-items-center" style={{ width: 120 }}>
      <div className="fz-14 text-start w-100">
        <div>{`$${paymentAmount ?? 0}`}</div>
        <div>{renderDate(paymentDate)}</div>
      </div>
    </div>
  );
}

export default React.memo(PaymentStatus);
